<div class="progress-container">
  <!--<progress class="progress" max="100" value="50">
  </progress>-->

  <div class="progress-materializecss">
    <div class="indeterminate"></div>
  </div>

</div>
